import { useSelector } from 'react-redux';
import { useState } from 'react';

import {
  getDecisionDataId,
  getDecisionKnoOrganizationFormValue,
  getDecisionMassCancel,
  getKnmIsDecisionStatusTypeCanceled,
} from '../../MainModule/selectors/decisionSelectors';
import styles from './DecisionMassCancelHeader.module.scss';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import { KnmMassCancelDetailModal } from '../../../KnmPackage/KnmHeaderModule/components/KnmMassCancelDetailModal';
import { getAccountOrganizationsWithDistrictData } from '../../../CorePackage/AccountModule/selectors/accountSelectors';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { KnmMassCancelModal } from '../../../KnmPackage/KnmHeaderModule/components/KnmMassCancelModal';

export const DecisionMassCancelHeader = () => {
  const decisionId = useSelector(getDecisionDataId);
  const massCancel = useSelector(getDecisionMassCancel);
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const knoOrganization = useSelector(getDecisionKnoOrganizationFormValue);
  const userKnoOrganisations = useSelector(getAccountOrganizationsWithDistrictData).kno;
  const isDecisionStatusTypeCanceled = useSelector(getKnmIsDecisionStatusTypeCanceled);
  const [isShowDetailModal, setIsShowDetailModal] = useState(false);
  const [isShowCancelModal, setIsShowCancelModal] = useState(false);
  const isCancelButtonEnabled =
    isSupervisor &&
    userKnoOrganisations.some(
      item => item.id === knoOrganization?.id?.toString() || item.id === knoOrganization?.idStr?.toString(),
    );

  if (!massCancel?.isCancellationAllowed || isDecisionStatusTypeCanceled) {
    return null;
  }

  return (
    <>
      <div className={styles.Block}>
        <span className={styles.WarningText}>
          Внимание! Данное мероприятие отмечено прокурором как подлежащее отмене!
        </span>
        <Button
          text="Просмотреть основание"
          variant="link"
          color="primary"
          type="button"
          onClick={() => setIsShowDetailModal(true)}
        />
        <div className={styles.Space}></div>
        <Button
          text="Отменить мероприятиe"
          color="danger"
          type="button"
          disabled={!isCancelButtonEnabled}
          onClick={() => setIsShowCancelModal(true)}
        />
      </div>
      <KnmMassCancelDetailModal
        visible={isShowDetailModal}
        onClose={() => setIsShowDetailModal(false)}
        massCancel={massCancel}
      />
      <KnmMassCancelModal
        visible={isShowCancelModal}
        onClose={() => setIsShowCancelModal(false)}
        passportId={decisionId}
      />
    </>
  );
};
